import axios from "axios";

export default {
  data() {
    return {
      persons: [],
      namePersons: []
    };
  },

  methods: {
    getPersons() {
      let path = this.$store.state.endpoint + "/person";
      axios
        .get(path)
        .then(response => {
          this.persons = response.data.sort((a, b) => { return a.preferred_name.family_name > b.preferred_name.family_name; })
        })
        .catch(error => {
          console.log(error);
        });
    },
    getNamePersons() {
      let path = this.$store.state.endpoint + "/personName";
      axios
        .get(path)
        .then(response => {
          response.data.forEach(item => {
            this.namePersons.push({
              id: item.id,
              name:
                item.preferred_name.given_name +
                " " +
                item.preferred_name.family_name
            });
          });
          this.namePersons.sort((a, b) => { return a.name > b.name; })
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
